const EXACT = 1000;
const PREFIX = 800;
const WORD_START = 600;
const SUBSTRING = 400;
const TYPO = 200;

function levenshteinDistance(a, b) {
  const rows = a.length + 1;
  const cols = b.length + 1;
  const matrix = Array.from({ length: rows }, (_, i) => [i, ...Array(cols - 1).fill(0)]);
  for (let j = 1; j < cols; j += 1) matrix[0][j] = j;

  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      );
    }
  }

  return matrix[rows - 1][cols - 1];
}

function bestTypoDistance(name, query) {
  const maxDistance = Math.max(1, Math.floor(query.length / 3));
  const distance = levenshteinDistance(name, query);
  return distance <= maxDistance ? distance : -1;
}

export function scoreMatch(name, query) {
  if (!name || !query) return -1;
  const n = name.toLowerCase();
  const q = query.toLowerCase();
  const idx = n.indexOf(q);

  if (idx !== -1) {
    if (n === q) return EXACT;
    if (idx === 0) return PREFIX - n.length;
    const prevChar = n[idx - 1];
    if (prevChar === " " || prevChar === "-" || prevChar === "_" || prevChar === "/" || prevChar === "&") {
      return WORD_START - n.length;
    }
    return SUBSTRING - idx - n.length * 0.1;
  }

  const typoDist = bestTypoDistance(n, q);
  if (typoDist === -1) return -1;
  return TYPO - typoDist * 30 - n.length * 0.1;
}

export function rankResults(items, query) {
  if (!query) return items;
  return items
    .map((item) => ({ item, score: scoreMatch(item.label, query) }))
    .filter(({ score }) => score >= 0)
    .sort((a, b) => b.score - a.score)
    .map(({ item }) => item);
}
